import { useId } from 'react';
import { useFocusRing } from 'react-aria';

import { webAppSettingsStore } from '../../store/web-app-settings/WebAppSettingsStore';

import { useI18n } from '../../hooks/useI18nFormatters';
import { useWebAppSettings } from '../../store/web-app-settings/useWebAppSettings';

import styles from './ScriptTypeCheckingToggle.module.css';

import { Switch } from '../../components/forms/Switch';

export function ScriptTypeCheckingToggle() {
  const { i18n } = useI18n();
  const { settings } = useWebAppSettings();
  const id = useId();
  const focusRing = useFocusRing({ within: true });
  const label = i18n.messageFormatter('script.typeChecking');

  function handleTypeCheckingChange(isEnabled: boolean) {
    webAppSettingsStore.set({ homeyScriptTypeChecking: isEnabled });
  }

  return (
    <div
      {...focusRing.focusProps}
      className={styles.root}
      data-is-focus-visible={focusRing.isFocusVisible}
    >
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <Switch
        id={id}
        name="homeyScriptTypeChecking"
        aria-label={label}
        value={settings.homeyScriptTypeChecking === true}
        onChange={handleTypeCheckingChange}
      />
    </div>
  );
}
